<template>
  <section id="missionSponsors">
    <div class="container">
      <h2>Mission Sponsors</h2>
      <div v-for="location in sponsors">
        <h3 v-html="location.location"></h3>
        <div class="sponsor" v-for="sponsor in location.sponsors">
          <div class="logo"><img :src="sponsor.logo.sizes.medium" class="img-fluid"></div>
          <div class="content">
            <p><strong class="upcase"><span v-html="sponsor.sponsor_type"></span>:</strong> <span v-html="sponsor.description"></span></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'mission-sponsors',
  props: ['sponsors']
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

section {
  padding: 7rem 0 6rem;
  background-color: lighten($gold, 15%);
  .container {
    @include media('desktop') {
      width: 830px;
    }
  }
}

h2 {
  color: $brand-primary;
  margin-bottom: 3rem;
  text-align: center;
}

h3 {
  margin-top: 5rem;
  margin-bottom: 2rem;
  text-align: center;
  @include media('tablet') {
    text-align: left;
    margin-left: calc(220px + 5rem);
  }
}

.sponsor {
  text-align: center;
  @include media('tablet') {
    display: flex;
    text-align: left;
    align-items: center;
  }
  margin-bottom: 3.25rem;
  .logo {
    width: 220px;
    margin: 0 auto 2rem;
    @include media('tablet') {
      margin-bottom: 0;
      margin-right: 5rem;
    }
  }
  .content {
    flex: 1;
    p {
      strong {
        text-transform: uppercase;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// MissionSponsors.vue?851f608a